import React from 'react';
import { TPAComponentProps } from '../../types';

export interface PaginationProps extends TPAComponentProps {
  /** hook for testing purposes */
  'data-hook'?: string;
  // data
  totalPages: number;
  currentPage?: number;
  // props
  pageUrl?(pageNumber: number): string;
  onChange?(event: { event: React.SyntheticEvent; page: number }): void;
  onClick?: React.MouseEventHandler<HTMLElement>;
  onDoubleClick?: React.MouseEventHandler<HTMLElement>;
  onMouseEnter?: React.MouseEventHandler<HTMLElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLElement>;
  paginationMode?: 'pages' | 'input' | 'compact' | PaginationMode;
  showFirstLastNavButtons?: boolean;
  firstLabel?: React.ReactNode;
  previousLabel?: React.ReactNode;
  nextLabel?: React.ReactNode;
  lastLabel?: React.ReactNode;
  gapLabel?: React.ReactNode;
  slashLabel?: React.ReactNode;
  // Text which is passed to input when pagination mode is 'input'
  inputAriaLabel?: string;
  rtl?: boolean;
  width?: number;
  showFirstPage?: boolean;
  showLastPage?: boolean;
  showNextLabel?: boolean;
  showPreviousLabel?: boolean;
  showInputModeTotalPages?: boolean;
  responsive?: boolean;
  maxPagesToShow?: number;
  className?: string;
  id?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  /** Internal prop, should never be used by consumers! */
  customLabels?: {
    first?: boolean;
    previous?: boolean;
    next?: boolean;
    last?: boolean;
  };
}

export const enum ButtonType {
  Prev = 'previous',
  Next = 'next',
  First = 'first',
  Last = 'last',
}

export const enum PaginationMode {
  Pages = 'pages',
  Compact = 'compact',
  Input = 'input',
}

export interface PaginationState {
  pageInputValue: string;
  pageInputHasError: boolean;
}
